import { observable } from "mobx";
import { Type } from "class-transformer";
import CounterpartyBankAccountType from "./counterpartyBankAccountType";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class TransferPaymentResponse {
  /**
   * Payment ID.
   */
  id!: string;

  /**
   * Payment template ID.
   */
  @observable
  paymentTemplateId?: string;

  /**
   * Bank transaction id.
   */
  @observable
  bankTransactionId!: string;

  /**
   * Bank transaction type.
   */
  @observable
  bankTransactionType!: string;

  /**
   * Counterparty account number.
   */
  @observable
  counterpartyAccountNumber?: string;

  /**
   * Counterparty bank.
   */
  @observable
  counterpartyBank?: string;

  /**
   * Counterparty name.
   */
  @observable
  counterpartyName?: string;

  /**
   * Counterparty account type.
   */
  @observable
  counterpartyAccountType!: CounterpartyBankAccountType;

  /**
   * Amount.
   */
  @observable
  amount!: number;

  /**
   * Variable symbol.
   */
  @observable
  variableSymbol?: number;

  /**
   * Specific symbol.
   */
  @observable
  specificSymbol?: number;

  /**
   * Constant symbol.
   */
  @observable
  constantSymbol?: number;

  /**
   * New variable symbol.
   */
  @observable
  newVariableSymbol?: number;

  /**
   * Message for recipient.
   */
  @observable
  messageForRecipient?: string;

  /**
   * Additional information.
   */
  @observable
  additionalInformation?: string;

  /**
   * Statement date.
   */
  @observable
  @Type(() => Date)
  statementDate!: Date;
}
